import {
  getPricingTemplatesAPI,
  getWeightTolerancesAPI,
  createPricingTemplateAPI,
  updatePricingTemplateAPI,
  deletePricingTemplateAPI,
  getPriceBreaksAPI,
} from '../api/pricingTemplate'
import { SET_PRICING_TEMPLATES, SET_WEIGHT_TOLERANCES } from '../types/pricingTemplate'
import { addMessageCurry, commonActionAPIHit } from '../utils/api'

export const setPricingTemplates = (payload) => ({
  type: SET_PRICING_TEMPLATES,
  payload,
})

export const setWeightTolerances = (payload) => ({
  type: SET_WEIGHT_TOLERANCES,
  payload,
})

/* export const setPriceBreaks = payload => ({
    type: SET_PRICE_BREAKS,
    payload
}) */

export const getPricingTemplates = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getPricingTemplatesAPI(), dispatch)
        .then((pricingTemplates) => {
          resolve(pricingTemplates)
          dispatch(setPricingTemplates({ pricingTemplates }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getWeightTolerances = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getWeightTolerancesAPI(), dispatch)
        .then((weightTolerances) => {
          resolve(weightTolerances)
          dispatch(setWeightTolerances({ weightTolerances }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getPriceBreaks = (weightPerUnit) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getPriceBreaksAPI(weightPerUnit), dispatch)
        .then((priceBreaks) => {
          resolve(priceBreaks)
          //dispatch(setPriceBreaks({priceBreaks}))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const createPricingTemplate = (pricingTemplate) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(createPricingTemplateAPI(pricingTemplate), dispatch)
        .then((pricingTemplate) => {
          dispatch(getPricingTemplates())
          resolve(pricingTemplate)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export const updatePricingTemplate = (pricingTemplate) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updatePricingTemplateAPI(pricingTemplate), dispatch)
        .then((pricingTemplate) => {
          dispatch(getPricingTemplates())
          resolve(pricingTemplate)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export const deletePricingTemplate = commonActionAPIHit(deletePricingTemplateAPI)



// WEBPACK FOOTER //
// ./src/actions/pricingTemplate.js